// This function allow to reference async chunks
__webpack_require__.miniCssF = (chunkId) => {
	// return url for filenames based on template
	return "static/css/" + {"3758":"56781140b4ed6335","9528":"c1bf5108cc33b486"}[chunkId] + ".css";
};